/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { registerLicense } from '@syncfusion/ej2-base';
import * as Sentry from "@sentry/angular";


Sentry.init({
  dsn: "https://493402d1ce98561df44cb7f0e9d09d27@o4508960851689472.ingest.de.sentry.io/4509592483725392",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: environment.production ? 'production' : environment.testing ? 'testing' : 'development',
  integrations: [
    Sentry.httpClientIntegration(),
    Sentry.replayIntegration(
      {
        maskAllText: false, // Masks all text content in the replay
        blockAllMedia: false, // Blocks all media content in the replay
        maskAllInputs: false, // Masks all input fields in the replay                
      },
    ),
  ],
  // Session Replay
  replaysSessionSampleRate: environment.production ? 0.1 : 1.0,//0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


registerLicense('Ngo9BigBOggjGyl/VkR+XU9Ff1RDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3hTdURjWXpfeXVXRWZbUU91XQ==');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
